/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnassignTagMutationVariables = Types.Exact<{
  input: Types.InputMaybe<Types.TagAssignInput>;
}>;


export type UnassignTagMutation = { __typename: 'Mutation', unassignTag: { __typename: 'TagAssignResponse', result: string | null } | null };


export const UnassignTagDocument = gql`
    mutation unassignTag($input: TagAssignInput) {
  unassignTag(input: $input) {
    result
  }
}
    `;
export type UnassignTagMutationFn = Apollo.MutationFunction<UnassignTagMutation, UnassignTagMutationVariables>;

/**
 * __useUnassignTagMutation__
 *
 * To run a mutation, you first call `useUnassignTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTagMutation, { data, loading, error }] = useUnassignTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignTagMutation(baseOptions?: Apollo.MutationHookOptions<UnassignTagMutation, UnassignTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignTagMutation, UnassignTagMutationVariables>(UnassignTagDocument, options);
      }
export type UnassignTagMutationHookResult = ReturnType<typeof useUnassignTagMutation>;
export type UnassignTagMutationOptions = Apollo.BaseMutationOptions<UnassignTagMutation, UnassignTagMutationVariables>;